var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _path7, _rect5, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#BC3618"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4176 111V41.1818H78.5994C83.9631 41.1818 88.4631 42.1818 92.0994 44.1818C95.7585 46.1818 98.5199 48.9318 100.384 52.4318C102.27 55.9091 103.213 59.8636 103.213 64.2955C103.213 68.7727 102.27 72.75 100.384 76.2273C98.4972 79.7045 95.7131 82.4432 92.0312 84.4432C88.3494 86.4205 83.8153 87.4091 78.429 87.4091H61.0767V77.0114H76.7244C79.8608 77.0114 82.429 76.4659 84.429 75.375C86.429 74.2841 87.9063 72.7841 88.8608 70.875C89.8381 68.9659 90.3267 66.7727 90.3267 64.2955C90.3267 61.8182 89.8381 59.6364 88.8608 57.75C87.9063 55.8636 86.4176 54.3977 84.3949 53.3523C82.3949 52.2841 79.8153 51.75 76.6562 51.75H65.0653V111H52.4176ZM114.199 111V41.1818H140.381C145.744 41.1818 150.244 42.1818 153.881 44.1818C157.54 46.1818 160.301 48.9318 162.165 52.4318C164.051 55.9091 164.994 59.8636 164.994 64.2955C164.994 68.7727 164.051 72.75 162.165 76.2273C160.278 79.7045 157.494 82.4432 153.812 84.4432C150.131 86.4205 145.597 87.4091 140.21 87.4091H122.858V77.0114H138.506C141.642 77.0114 144.21 76.4659 146.21 75.375C148.21 74.2841 149.688 72.7841 150.642 70.875C151.619 68.9659 152.108 66.7727 152.108 64.2955C152.108 61.8182 151.619 59.6364 150.642 57.75C149.688 55.8636 148.199 54.3977 146.176 53.3523C144.176 52.2841 141.597 51.75 138.438 51.75H126.847V111H114.199ZM172.912 51.7841V41.1818H228.616V51.7841H207.037V111H194.491V51.7841H172.912Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252 328H402C402 245.157 334.843 178 252 178V328Z",
    fill: "#FF8F6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252 328V178C169.157 178 102 245.157 102 328H252Z",
    fill: "#ED6C47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252 328H102C102 410.843 169.157 478 252 478L252 328Z",
    fill: "#D35230"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252 328L252 478C334.843 478 402 410.843 402 328H252Z",
    fill: "#D35230"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 223,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#BC3618"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.343 353V273H164.905C170.973 273 176.142 274.159 180.413 276.477C184.684 278.768 187.939 281.958 190.179 286.047C192.444 290.109 193.577 294.797 193.577 300.109C193.577 305.422 192.431 310.109 190.14 314.172C187.848 318.234 184.528 321.398 180.179 323.664C175.856 325.93 170.621 327.062 164.476 327.062H144.358V313.508H161.741C164.996 313.508 167.679 312.948 169.788 311.828C171.924 310.682 173.512 309.107 174.554 307.102C175.621 305.07 176.155 302.74 176.155 300.109C176.155 297.453 175.621 295.135 174.554 293.156C173.512 291.151 171.924 289.602 169.788 288.508C167.653 287.388 164.944 286.828 161.663 286.828H150.257V353H133.343Z",
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1104",
    x: 40.418,
    y: 41.1836,
    width: 192.199,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1104",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.cef664aaa69fe749962fc863e35c7f80.svg";
export { ForwardRef as ReactComponent };